<div class="outer">


  <div class="content-container">

    <p class="question">{{title}}</p>

    @if (!expanded) {
      <button id="expand" (click)="onExpand()" class="btn btn-outline-primary btn-outline">Expand</button>
    }

    @if (expanded) {
      <div class="container">
        <div class="card">
          <carousel [page]="page" [itemHeight]="340" (iveSeenEverything)="onIveSeenEverything(event)">
            @for (page of pages; track page) {
              <ng-container *carouselItem>
                <div class="item">
                  @for (element of page.elements; track element) {
                    @if (element.type == 'header') {
                      <h4 class="answer-header">{{element.value}}</h4>
                    }
                    @if (element.type == 'br') {
                      <br/>
                    }
                    @if (element.type == 'hr') {
                      <hr/>
                    }
                    @if (element.type == 'ul') {
                      <ul>
                        @for (el of element.elements; track el) {
                          <li>{{el.value}}</li>
                        }
                      </ul>
                    }
                    @if (element.type == 'p') {
                      <p [innerHTML]="element.value"></p>
                    }
                  }
                </div>
              </ng-container>
            }
          </carousel>
        </div>
      </div>
    }



    <div class="buttons">

      <div [hidden]="showBack" id="fake-button" style="height:48px;margin-bottom:50px;margin-top:19px;float:left;"></div>

      <button id="backD" (click)="onBack()" class="btn btn-outline-primary btn-outline" [hidden]="!expanded || !showBack">Back</button>

      <button id="nextD" (click)="onNext()" class="btn btn-outline-primary btn-outline"
      [hidden]="!showNext || !expanded ">{{this.maxCount === this.currentIndex + 1 ? 'Finish' : 'Next'}}</button>


    </div>


  </div>
</div>

<app-progress-bar [progressValue]=controller.getProgress()></app-progress-bar>
